<template>
  <div class="container">
    <mt-header fixed title="发票管理" class="head" >
      <router-link to="/account" slot="left">
        <mt-button icon="back"></mt-button>
      </router-link>
    </mt-header>
    <div class="loadmore-container">
      <!--<mt-loadmore :top-method="loadTop" ref="loadmore" :bottom-method="loadBottom"  :bottomDropText="params.bottomDropText"  :bottom-all-loaded="allLoaded">-->
      <mt-loadmore :top-method="loadTop" ref="loadmore" >
        <ul class="c_p_10" v-infinite-scroll="scroll_load" :infinite-scroll-disabled="loading" infinite-scroll-distance="1">
          <li class="item" v-for="(item,index) in list" :key="index" @click="js_detail(item)">
            <div class="c_blue"><span>合同编号</span>：<span>{{item.contractdocunum}}</span></div>
            <div class="c_m_t_10"><span>工程编号</span>：<span>{{item.servicecode}}</span></div>
            <div class="c_m_t_10"><span>甲方名称</span>：<span>{{item.customername}}</span></div>
            <div class="c_m_t_10"><span>联系方式</span>：<span>{{item.customerPhone}}</span></div>
            <div class="c_m_t_10"><span>签署时间</span>：<span>{{item.createtime | getDatetime}}</span></div>
            <div class="c_m_t_10 c_right">
              <div class="item-detail bg_blue">查看详情</div>
            </div>
          </li>
          <li class="c_size_10 c_gray c_p_10 c_center c_flex c_flex_center" v-show="list.length<1 &&(!showLoading)">
            <div class="c_gray">您还没有质保</div>
          </li>
          <li class="c_size_10 c_gray c_p_10 c_center c_flex c_flex_center" v-show="showLoading">
            <mt-spinner type="snake" color="#00ccff" :size="20" v-show="!stopload"></mt-spinner>
            <span v-show="stopload">已经是最后一页了</span>
          </li>
        </ul>
      </mt-loadmore>
    </div>
  </div>
</template>

<script>
  export default {
    name: "invoice",
    data:function () {
      return {
        page_params:{
          pageIndex:0,
          pageSize:5,
          totalPages:1,
          bottomDropText:'释放加载',
        },
        // 合同列表
        list:[
        ],

        // 无限滚动
        loading:false,
        showLoading:false,
        stopload:false,
      };
    },
    methods:function(){
      this.loadList();
    },
    methods:{
      loadList:function(callback){
        let $that = this;
        this.$indicator.open();
        this.$ajax.get(this.$$api.mobile.getContractList, {
          //pageIndex: $that.page_params.pageIndex,
          //pageSize: $that.page_params.pageSize,
          //'sortField':'ts',
          //'sortDirection':'desc',
        },response=>{
          if (response.status >= 200 && response.status < 300) {
            if(response.data.success=='success'){
              var msg=response.data.detailMsg.data;
              console.log(msg);
              $that.page_params.pageIndex = msg.number+1;
              $that.page_params.totalPages = msg.totalPages;
              if(msg.number === 0){
                $that.list=msg.content;
              }else if(msg.number < msg.totalPages){
                $that.list = $that.list.concat(msg.content);
              }
            } else {
              console.log(response,0);
            }
            if(callback)callback();
            $that.$indicator.close();
          }
        });

      },
      // 下拉事件
      loadTop: function () {
        var $that = this;
        this.page_params.bottomDropText = '释放加载';
        $that.page_params.pageIndex = 0;
        $that.loadList(function () {
          setTimeout(function () {
            $that.$refs.loadmore.onTopLoaded();
          },500);
        });

      },
      loadBottom:function(event){
        var $that = this;
        var pageIndex = $that.page_params.pageIndex + 1;
        var totalPages = $that.page_params.totalPages;
        if(pageIndex >= totalPages){
          // 已经到最后一页了
          this.page_params.bottomDropText = '已经最后一页了';
          $that.$refs.loadmore.onBottomLoaded();
        }else{
          $that.page_params.pageIndex = pageIndex;
          $that.loadList(function () {
            setTimeout(function () {
              $that.$refs.loadmore.onBottomLoaded();
            },500);
          });
        }
      },
      js_detail:function(item){
        let detail = item.invoicephoto;
        if(detail){
          this.$router.push({name: "invoiceDetail", params: {'detail': detail}});
        }else{
          this.$toast({
            message: '还没有上传发票图片',
            duration: 2000
          });
        }
      },
      toBackClick:function () {
        this.$router.go(-1);
      },
      scroll_load:function () {
        if(this.loading){
          return;
        }
        this.loading = true;
        this.showLoading = true;
        var $that = this;
        var pageIndex = $that.page_params.pageIndex;
        var totalPages = $that.page_params.totalPages;
        if(pageIndex >= totalPages){
          // 已经到最后一页了
          this.stopload = true;
          setTimeout(function () {
            $that.showLoading = false;
            $that.loading = false;
          },2500);
        }else{
          this.stopload = false;
          $that.loadList(function () {
            $that.showLoading = false;
            $that.loading = false;
          });
        }
      },
    },
  }
</script>

<style scoped>
  .container{
    font-size: 4vw;
  }
  ul{
    list-style:none;
    margin:0;
    padding:0;
    min-height: 75vh;
  }
  .item {
    width: 100%;
    margin-bottom:3.226vw;
    text-align: left;
    box-sizing: border-box;
    padding: 3.226vw;
    word-wrap:break-word;
    background: #fff;
    border-radius: 5px;
  }
  .item-detail{
    display: inline-block;
    padding: .2rem .3rem;
    -webkit-border-radius: 5px;
    -moz-border-radius: 5px;
    border-radius: 5px;
    color: #fff;
  }
  /*loadmore*/
  /*.loadmore-container{*/
  /*height: 82vh;*/
  /*}*/
</style>



// WEBPACK FOOTER //
// src/components/invoice.vue